import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './core/errors/pagenotfound/pagenotfound.component';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { LoginErrorComponent } from "./core/errors/login-error/login-error.component";

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'private' },
  {
    path: 'private',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () =>
      import('./modules/private/private.module').then(m => m.PrivateModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/public/public.module').then(m => m.PublicModule)
  },
  { path: 'login-error', component: LoginErrorComponent },
  { path: '**', component: PageNotFoundComponent },
  { path: 'not-found', redirectTo: '**' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
